/* ROLES */
export const GET_AUDIT_TICKETS = "GET_AUDIT_TICKETS"
export const GET_AUDIT_TICKETS_SUCCESS = "GET_AUDIT_TICKETS_SUCCESS"
export const GET_AUDIT_TICKETS_FAIL = "GET_AUDIT_TICKETS_FAIL"

/**
 * Export Ticket Audit */
export const GET_EXPORT_AUDIT_TICKETS = "GET_EXPORT_AUDIT_TICKETS"
export const GET_EXPORT_AUDIT_TICKETS_SUCCESS =
  "GET_EXPORT_AUDIT_TICKETS_SUCCESS"
export const GET_EXPORTED_AUDIT_TICKETS_FAIL = "GET_EXPORTED_AUDIT_TICKETS_FAIL"
export const RESET_EXPORT_DATA = "RESET_EXPORT_DATA"

/**
 * CLEAR MESSAGE AND ERROR OBJECT
 */
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"
